import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { useEffect } from 'react';
import type { QueryHookError } from 'src/utils';

import { resolvePresentableQueryError } from '@/utils/formError';

export function useErrorNotification(error: QueryHookError, enabled: boolean) {
  const { addNotification } = useNotifications();
  const presentableError = error ? resolvePresentableQueryError(error) : null;

  useEffect(() => {
    if (enabled && presentableError) {
      addNotification({
        type: 'error',
        content: presentableError,
        id: `query-error:${presentableError}`,
      });
    }
  }, [enabled, presentableError, addNotification]);
}
